import { notifications } from '@mantine/notifications';

/**
 * Toast helper — wraps Mantine's notifications system with brand-voice defaults.
 *
 * Voice: no "Oops!", "Sorry!", "Awesome!" (per prd/02_voice.md). Default to plain
 * factual statements. Variants map to Mantine colour tokens; the `kind` alias
 * matches the older slice contract for backward-compat with callers that pass
 * `{ kind, title, body }`.
 */
export type ToastKind = 'info' | 'success' | 'warning' | 'error';

export type ToastOpts = {
  title?: string;
  /** Preferred body field. */
  body?: string;
  /** Legacy alias for `body`. */
  message?: string;
  /** Preferred variant field. */
  kind?: ToastKind;
  /** Legacy alias for `kind`. */
  variant?: ToastKind;
};

export function showToast(opts: ToastOpts): void {
  const message = opts.body ?? opts.message ?? '';
  const kind = opts.kind ?? opts.variant;

  // Mantine's NotificationData treats title as a discriminated optional under
  // exactOptionalPropertyTypes — build the object conditionally rather than
  // passing undefined.
  const color =
    kind === 'error'
      ? 'red'
      : kind === 'warning'
        ? 'yellow'
        : kind === 'success'
          ? 'green'
          : undefined;
  notifications.show({
    ...(opts.title === undefined ? {} : { title: opts.title }),
    message,
    ...(color === undefined ? {} : { color }),
  });
}
